module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_9016.9638fe5d.png";